ixModuleRouting("impactx.sso", {
    "/samlssosettings": {
        template: "<ixa-saml-sso-settings></ixa-saml-sso-settings>",
        process: "SamlSSOSettings",
        workspace: "system",
    },
    "/openidsettings": {
        template: "<ixa-openid-settings></ixa-openid-settings>",
        process: "OpenIdSettings",
        workspace: "system",
    },
});
